export function requireAsPromise(
    deps: string[],
    onLoaded: (...mods: unknown[]) => void,
): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        // The browser provides RequireJS rather than the host's Node require type.
        const legacyWindow = window as unknown as {
            require: (
                deps: string[],
                onLoad: (...mods: unknown[]) => void,
                onError: (error: unknown) => void,
            ) => void;
        };
        legacyWindow.require(
            deps,
            (...mods) => {
                try {
                    onLoaded(...mods);
                    resolve();
                } catch (error) {
                    reject(error);
                }
            },
            reject,
        );
    });
}
